import { TheKnotAdapter } from '~/apps/main/TheKnot/the-knot.adapter';

export class TheKnotService extends TheKnotAdapter {}
